import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'add_card_file';

export const useAddCardFileTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Добавить файл',
    name: 'Название',
    submit: 'Сохранить',
    cancel: 'Отмена',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Add file',
    name: 'Name',
    submit: 'Save',
    cancel: 'Cancel',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Añadir archivo',
    name: 'Nombre',
    submit: 'Guardar',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Adicionar arquivo',
    name: 'Nome',
    submit: 'Salvar',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;
